<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/c27XOZ/tc-custom/9781982157487.jpg?1730521357621" alt="This image is the cover for the book Make Russia Great Again"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Make Russia Great Again
      </h1>
      <p class="bookDescription body article font2">
        <b>In “the Trump satire we’ve been waiting for” (<i>The Washington Post</i>), award-winning and bestselling author of <i>Thank You for Smoking</i> delivers a hilarious and whipsmart fake memoir by Herb Nutterman—Donald Trump’s seventh chief of staff—who has written the ultimate tell-all about Trump and Russia.</b><br/><br/>Herb Nutterman never intended to become Donald Trump’s White House chief of staff. Herb served the Trump Organization for twenty-seven years, holding jobs in everything from a food and beverage manager at the Trump Magnifica to being the first general manager of the Trump Bloody Run Golf Course. And when his old boss asks “his favorite Jew” to take on the daunting role of chief of staff, Herb, spurred on by loyalty agrees.<br/><br/>But being the chief of staff is a lot different from being a former hospitality expert. Soon, Herb finds himself deeply involved in Russian intrigue, deflecting rumors about Mike Pence’s high school involvement in a Satanic cult, and leading President Trump’s reelection campaign.<br/><br/>What Nutterman experiences is outrageous, outlandish, and otherwise unbelievable—therefore making it a deadly accurate account of being the chief of staff during the Trump administration. With hilarious jabs at the biggest world leaders and Washington politics overall, <i>Make Russia Great Again </i>is a timely political satire from “one of the funniest writers in the English language” (Tom Wolfe).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Buckley
      </h2>
      
      <p class="authorDescription body article">Christopher Buckley is a novelist, essayist, humorist, critic, magazine editor, and memoirist. His books include&#160;<I>Thank You for Smoking</I>,&#160;<I>The Judge Hunter</I>,&#160;<I>Make Russia Great Again</I>, and&#160;<I>The Relic Master</I>. He worked as a merchant seaman and White House speechwriter. He was awarded the Thurber Prize for American Humor and the Washington Irving Medal for Literary Excellence.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon & Schuster
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3fbd7933